/** leads/capParse.ts — 증자 파일(엑셀/CSV) 헤더 별칭 → 표준 행 (순수함수) */
export interface CapRow {
  biz_no: string | null; corp_no: string | null; corp_name: string; increase_year: number;
  increase_date: string | null; amount: number | null; address: string;
}

const H: Record<string, string> = {
  '사업자등록번호': 'biz_no', '사업자번호': 'biz_no',
  '법인등록번호': 'corp_no', '법인번호': 'corp_no',
  '법인명': 'corp_name', '상호': 'corp_name', '회사명': 'corp_name', '기업명': 'corp_name', '업체명': 'corp_name',
  '증자일': 'increase_date', '증자일자': 'increase_date', '변경일': 'increase_date', '변경일자': 'increase_date', '등기일': 'increase_date', '등기일자': 'increase_date',
  '증자연도': 'increase_year', '변경연도': 'increase_year', '연도': 'increase_year',
  '증자금액': 'amount', '증가액': 'amount', '증자액': 'amount', '증가자본금': 'amount', '금액': 'amount',
  '주소': 'address', '본점주소': 'address', '소재지': 'address', '본점소재지': 'address',
};

function toDate(v: unknown): string | null {
  // 버그수정(2026-08-11): SheetJS Date 로컬 자정 → toISOString KST 전날 밀림. 로컬 기준 변환.
  if (v instanceof Date && !isNaN(v.getTime())) { const p = (n: number) => String(n).padStart(2, '0'); return v.getFullYear() + '-' + p(v.getMonth() + 1) + '-' + p(v.getDate()); }
  const t = String(v || '').trim().replace(/[./]/g, '-');
  return /^\d{4}-\d{2}-\d{2}$/.test(t) ? t : null;
}

export function parseCapRows(objs: Record<string, unknown>[]): { rows: CapRow[]; skipped: number } {
  const rows: CapRow[] = [];
  let skipped = 0;
  for (const raw of objs) {
    const o: Record<string, unknown> = {};
    Object.keys(raw).forEach((k) => { const m = H[String(k).replace(/\s/g, '')]; if (m) o[m] = raw[k]; });
    const corp = String(o.corp_name || '').trim();
    const date = toDate(o.increase_date);
    let year = parseInt(String(o.increase_year || ''), 10);
    if (!year && date) year = parseInt(date.slice(0, 4), 10);
    if (!corp || !year || year < 1990) { skipped++; continue; }
    const digits = String(o.biz_no || '').replace(/[^0-9]/g, '');
    const corpNo = String(o.corp_no || '').replace(/[^0-9]/g, '');
    const amtRaw = String(o.amount == null ? '' : o.amount).replace(/[^0-9.]/g, '');
    rows.push({
      biz_no: digits.length === 10 ? digits : null,
      corp_no: corpNo.length === 13 ? corpNo : null,
      corp_name: corp.slice(0, 200),
      increase_year: year,
      increase_date: date,
      amount: amtRaw ? Math.round(Number(amtRaw)) : null,
      address: String(o.address || '').trim().slice(0, 1000),
    });
  }
  return { rows, skipped };
}
